import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  initialState,
  RecoveryStep
} from '@/modules/utilities/setPassword/store/setPasswordSlice/initialState.ts'

const setPasswordSlice = createSlice({
  name: 'setPasswordSlice',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setCurrentStep: (state, action: PayloadAction<RecoveryStep>) => {
      state.currentStep = action.payload
    },
    setEmail: (state, action: PayloadAction<string | null>) => {
      state.email = action.payload
    },
    setToken: (state, action: PayloadAction<string | null>) => {
      state.token = action.payload
    },
    reset: () => initialState
  }
})

export const setPasswordActions = setPasswordSlice.actions
export const { reducer: setPasswordReducer } = setPasswordSlice
